// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".rk-picture[data-v-b3c3f556]{position:relative}.rk-picture__loader[data-v-b3c3f556]{align-items:center;display:flex;height:100%;left:0;position:absolute;top:0;width:100%;--tw-bg-opacity:1;background-color:#f1f5f9;background-color:rgba(241,245,249,var(--tw-bg-opacity))}img[data-v-b3c3f556],picture[data-v-b3c3f556]{color:transparent;position:relative}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
